import axios from "axios";
import * as types from "./actionTypes";

export let BASE_URL_EVENT;
export let BASE_URL_MEDIA;
export let BASE_URL_FLORAHUB;
export let BASE_URL_WISHLIST;
export let BASE_URL_USER;
export let BASE_URL_SEARCH;
export let BASE_URL_TEMPLATE;
export let BASE_URL_PAYMENT;
export let BASE_TEMP_IMG;
export let BASE_URL_BAG;

if (process.env.NODE_ENV === "production") {
  BASE_URL_EVENT = process.env.REACT_APP_API_URL_EVENT;
  BASE_URL_MEDIA = process.env.REACT_APP_API_URL_MEDIA;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_WISHLIST = process.env.REACT_APP_API_URL_WISHLIST;
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_SEARCH = process.env.REACT_APP_API_URL_SEARCH;
  BASE_URL_TEMPLATE = process.env.REACT_APP_API_URL_TEMPLATE;
  BASE_URL_PAYMENT = process.env.REACT_APP_API_URL_PAYMENT;
  BASE_TEMP_IMG = process.env.REACT_APP_TEMP_IMG;
  BASE_URL_BAG = process.env.REACT_APP_API_URL_BAG;
} else {
  BASE_URL_EVENT = process.env.REACT_APP_API_URL_EVENT;
  BASE_URL_MEDIA = process.env.REACT_APP_API_URL_MEDIA;
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_WISHLIST = process.env.REACT_APP_API_URL_WISHLIST;
  BASE_URL_USER = process.env.REACT_APP_API_URL_USER;
  BASE_URL_SEARCH = process.env.REACT_APP_API_URL_SEARCH;
  BASE_URL_TEMPLATE = process.env.REACT_APP_API_URL_TEMPLATE;
  BASE_URL_PAYMENT = process.env.REACT_APP_API_URL_PAYMENT;
  BASE_TEMP_IMG = process.env.REACT_APP_TEMP_IMG;
  BASE_URL_BAG = process.env.REACT_APP_API_URL_BAG;
}

const accessToken = localStorage.getItem("token");

const getBannerRequest = () => {
  return {
    type: types.GET_BANNER_REQUEST,
  };
};

const getBannerSuccess = (payload) => {
  return {
    type: types.GET_BANNER_SUCCESS,
    payload,
  };
};

const getBannerError = () => {
  return {
    type: types.GET_BANNER_ERROR,
  };
};
// INTERNAL
const getInternalBannerRequest = () => {
  return {
    type: types.GET_INTERNAL_BANNER_REQUEST,
  };
};

const getInternalBannerSuccess = (payload) => {
  return {
    type: types.GET_INTERNAL_BANNER_SUCCESS,
    payload,
  };
};

const getInternalBannerError = () => {
  return {
    type: types.GET_INTERNAL_BANNER_ERROR,
  };
};

const fetchInspirationBoardRequest = () => ({
  type: types.FETCH_INSPIRATION_BOARD_REQUEST,
});

const fetchInspirationBoardSuccess = (filterInspiration) => ({
  type: types.FETCH_INSPIRATION_BOARD_SUCCESS,
  payload: filterInspiration,
});

const fetchInspirationBoardFailure = (error) => ({
  type: types.FETCH_INSPIRATION_BOARD_FAILURE,
  payload: error,
});

const getInterestRequest = () => {
  return {
    type: types.GET_INTEREST_REQUEST, // isLoading : true
  };
};

const getInterestSuccess = (payload) => {
  return {
    type: types.GET_INTEREST_SUCCESS,
    payload,
  };
};

const getInterestError = () => {
  return {
    type: types.GET_INTEREST_ERROR,
  };
};

const getInterest = (dispatch) => {
  dispatch(getInterestRequest());
  return axios
    .get(`${BASE_URL_USER}/api/v1/user/intersets`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getInterestSuccess(response.data.payload.intersetData))
    )
    .catch((e) => {
      dispatch(getInterestError());
    });
};

// SEND GREETING
const getGreetingSentRequest = () => {
  return {
    type: types.GET_SENT_GREETINGS_REQUEST, // isLoading : true
  };
};

const getGreetingSentSuccess = (payload) => {
  return {
    type: types.GET_SENT_GREETINGS_SUCCESS,
    payload,
  };
};

const getGreetingSentError = () => {
  return {
    type: types.GET_SENT_GREETINGS_ERROR,
  };
};

const getGreetingSentDetails = (dispatch) => {
  dispatch(getGreetingSentRequest());
  return axios
    .get(`${BASE_URL_EVENT}/all/send/greetings/?page=0&size=10`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getGreetingSentSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getGreetingSentError());
    });
};
// RECEIVE GREETING
const getGreetingReceiveRequest = () => {
  return {
    type: types.GET_RECEIVE_GREETINGS_REQUEST, // isLoading : true
  };
};

const getGreetingReceiveSuccess = (payload) => {
  return {
    type: types.GET_RECEIVE_GREETINGS_SUCCESS,
    payload,
  };
};

const getGreetingReceiveError = () => {
  return {
    type: types.GET_RECEIVE_GREETINGS_ERROR,
  };
};

const getGreetingReceiveDetails = (dispatch) => {
  dispatch(getGreetingReceiveRequest());
  return axios
    .get(`${BASE_URL_EVENT}/all/received/greetings/?page=0&size=10`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getGreetingReceiveSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getGreetingReceiveError());
    });
};

// CAKES AND CHOC
const getCakesRequest = () => {
  return {
    type: types.GET_ALL_CAKES_REQUEST, // isLoading : true
  };
};

const getCakesSuccess = (payload) => {
  return {
    type: types.GET_ALL_CAKES_SUCCESS,
    payload,
  };
};

const getCakesError = () => {
  return {
    type: types.GET_ALL_CAKES_ERROR,
  };
};

// cakes
const getCakes = (dispatch) => {
  dispatch(getCakesRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=HOME_BANNERS`)
    .then((response) => dispatch(getCakesSuccess(response.data)))
    .catch((e) => {
      dispatch(getCakesError());
    });
};

// BANQUET HALL
const getBanquetRequest = () => {
  return {
    type: types.GET_BANQUET_HALL_REQUEST, // isLoading : true
  };
};

const getBanquetSuccess = (payload) => {
  return {
    type: types.GET_BANQUET_HALL_SUCCESS,
    payload,
  };
};

const getBanquetError = () => {
  return {
    type: types.GET_BANQUET_HALL_ERROR,
  };
};

// Banquet
const getBanquet = (dispatch) => {
  dispatch(getBanquetRequest());
  return axios
    .get(`${BASE_URL_EVENT}/all/offered-services?page=0&size=20`)
    .then((response) =>
      dispatch(getBanquetSuccess(response.data.payload.content))
    )

    .catch((e) => {
      dispatch(getBanquetError());
    });
};

// GET GIFTS

const getGiftDiaryRequest = () => {
  return {
    type: types.GET_GIFT_DIARY_REQUEST, // isLoading : true
  };
};

const getGiftDiarySuccess = (payload) => {
  return {
    type: types.GET_GIFT_DIARY_SUCCESS,
    payload,
  };
};

const getGiftDiaryError = () => {
  return {
    type: types.GET_GIFT_DIARY_ERROR,
  };
};

const getGiftDairy = (dispatch) => {
  dispatch(getGiftDiaryRequest());
  return axios
    .get(`${BASE_URL_EVENT}/giftDiary/all/by-type?giftType=All`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) => dispatch(getGiftDiarySuccess(response.data.payload)))
    .catch((e) => {
      dispatch(getGiftDiaryError());
    });
};

// GIFT DIARY
const addGiftDiaryRequest = () => {
  return {
    type: types.ADD_GIFT_DIARY_REQUEST, // isLoading : true
  };
};

const addGiftDiarySuccess = (payload) => {
  return {
    type: types.ADD_GIFT_DIARY_SUCCESS,
    payload,
  };
};

const addGiftDiaryError = () => {
  return {
    type: types.ADD_GIFT_DIARY_ERROR,
  };
};

const addGiftDiary = (payload) => (dispatch) => {
  // middleware --> thunk
  if (payload) {
    dispatch(addGiftDiaryRequest()); // isLoading : -- true

    return axios
      .post(`${BASE_URL_EVENT}/giftDiary/create`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((r) => {
        dispatch(addGiftDiarySuccess());
      })
      .catch((e) => {
        dispatch(addGiftDiaryError());
      });
  }
};

// GET eVENTS

const getEventsRequest = () => {
  return {
    type: types.GET_MY_EVENTS_REQUEST, // isLoading : true
  };
};

const getEventsSuccess = (payload) => {
  return {
    type: types.GET_MY_EVENTS_SUCCESS,
    payload,
  };
};

const getEventsError = () => {
  return {
    type: types.GET_MY_EVENTS_ERROR,
  };
};

const getEventDetails = (dispatch) => {
  dispatch(getEventsRequest());
  return axios
    .get(`${BASE_URL_EVENT}/view/all?page=0&size=10`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getEventsSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getEventsError());
    });
};

//ORDERS

const getOrdersRequest = () => {
  return {
    type: types.GET_ORDERS_HISTORY_REQUEST, // isLoading : true
  };
};

const getOrdersSuccess = (payload) => {
  return {
    type: types.GET_ORDERS_HISTORY_SUCCESS,
    payload,
  };
};

const getOrdersError = () => {
  return {
    type: types.GET_ORDERS_HISTORY_ERROR,
  };
};

const getOrderHistory = (dispatch) => {
  dispatch(getOrdersRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/order/api/v1/order/orderHistory?page=0&size=100`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    .then((response) => {
      dispatch(getOrdersSuccess(response.data.payload.content));
    })
    .catch((e) => {
      dispatch(getOrdersError());
    });
};

// CATEGORY
const getCategoryRequest = () => {
  return {
    type: types.GET_CATEGORY_REQUEST, // isLoading : true
  };
};

const getCategorySuccess = (payload) => {
  return {
    type: types.GET_CATEGORY_SUCCESS,
    payload,
  };
};

const getCategoryError = () => {
  return {
    type: types.GET_CATEGORY_ERROR,
  };
};

// GET GROUP CONTACT
const getAllGroupsRequest = () => {
  return {
    type: types.GET_ALL_GROUP_REQUEST, // isLoading : true
  };
};

const getAllGroupsSuccess = (payload) => {
  return {
    type: types.GET_ALL_GROUP_SUCCESS,
    payload,
  };
};

const getAllGroupsError = () => {
  return {
    type: types.GET_ALL_GROUP_ERROR,
  };
};

// TRENDING GREETING
const getTrendingGreetingRequest = () => {
  return {
    type: types.GET_TRENDING_GREETING_REQUEST, // isLoading : true
  };
};

const getTrendingGreetingSuccess = (payload) => {
  return {
    type: types.GET_TRENDING_GREETING_SUCCESS,
    payload,
  };
};

const getTrendingGreetingError = () => {
  return {
    type: types.GET_TRENDING_GREETING_ERROR,
  };
};
// TRENDING INVITATIONS
const getTrendingInvitationRequest = () => {
  return {
    type: types.GET_TRENDING_INVITATION_REQUEST, // isLoading : true
  };
};

const getTrendingInvitationSuccess = (payload) => {
  return {
    type: types.GET_TRENDING_INVITATION_SUCCESS,
    payload,
  };
};

const getTrendingInvitationError = () => {
  return {
    type: types.GET_TRENDING_INVITATION_ERROR,
  };
};

// TRENDING PRODUCTS
const getTrendingProductRequest = () => {
  return {
    type: types.GET_TRENDING_PRODUCT_REQUEST, // isLoading : true
  };
};

const getTrendingProductSuccess = (payload) => {
  return {
    type: types.GET_TRENDING_PRODUCT_SUCCESS,
    payload,
  };
};

const getTrendingProductError = () => {
  return {
    type: types.GET_TRENDING_PRODUCT_ERROR,
  };
};

// ALL PRODUCTS
const getAllProductHomeRequest = () => {
  return {
    type: types.GET_ALL_PRODUCTS_HOME_REQUEST, // isLoading : true
  };
};

const getAllProductHomeSuccess = (payload) => {
  return {
    type: types.GET_ALL_PRODUCTS_HOME_SUCCESS,
    payload,
  };
};

const getAllProductHomeError = () => {
  return {
    type: types.GET_ALL_PRODUCTS_HOME_ERROR,
  };
};

// ALL HomeDecor
const getAllHomeDecorRequest = () => {
  return {
    type: types.GET_ALL_HOMEDECOR_REQUEST, // isLoading : true
  };
};

const getAllHomeDecorSuccess = (payload) => {
  return {
    type: types.GET_ALL_HOMEDECOR_SUCCESS,
    payload,
  };
};

const getAllHomeDecorError = () => {
  return {
    type: types.GET_ALL_HOMEDECOR_ERROR,
  };
};

// ALL POTS
const getAllPotsRequest = () => {
  return {
    type: types.GET_ALL_POTS_REQUEST, // isLoading : true
  };
};

const getAllPotsSuccess = (payload) => {
  return {
    type: types.GET_ALL_POTS_SUCCESS,
    payload,
  };
};

const getAllPotsError = () => {
  return {
    type: types.GET_ALL_POTS_ERROR,
  };
};

// ALL WISHFYFRAMES
const getWishfyFramesRequest = () => {
  return {
    type: types.GET_WISHFY_FRAMES_REQUEST, // isLoading : true
  };
};

const getWishfyFramesSuccess = (payload) => {
  return {
    type: types.GET_WISHFY_FRAMES_SUCCESS,
    payload,
  };
};

const getWishfyFramesError = () => {
  return {
    type: types.GET_WISHFY_FRAMES_ERROR,
  };
};

// Greet
const getGreetRequest = () => {
  return {
    type: types.GET_GREET_REQUEST,
  };
};

const getGreetSuccess = (payload) => {
  return {
    type: types.GET_GREET_SUCCESS,
    payload,
  };
};

const getGreetError = () => {
  return {
    type: types.GET_GREET_ERROR,
  };
};

// iNVITATIONS
const getInvitationRequest = () => {
  return {
    type: types.GET_INVITATION_REQUEST,
  };
};

const getInvitationSuccess = (payload) => {
  return {
    type: types.GET_INVITATION_SUCCESS,
    payload,
  };
};

const getInvitationError = () => {
  return {
    type: types.GET_INVITATION_ERROR,
  };
};

// ALL GREETINGS
const getAllGreetingsRequest = () => {
  return {
    type: types.GET_ALL_GREETINGS_REQUEST,
  };
};

const getAllGreetingsSuccess = (payload) => {
  return {
    type: types.GET_ALL_GREETINGS_SUCCESS,
    payload,
  };
};

const getAllGreetingsError = () => {
  return {
    type: types.GET_ALL_GREETINGS_ERROR,
  };
};

// ALL iNVITATIONS
const getAllInvitationRequest = () => {
  return {
    type: types.GET_ALL_INVITATION_REQUEST,
  };
};

const getAllInvitationSuccess = (payload) => {
  return {
    type: types.GET_ALL_INVITATION_SUCCESS,
    payload,
  };
};

const getAllInvitationError = () => {
  return {
    type: types.GET_ALL_INVITATION_ERROR,
  };
};

// CATEGORU GROUPS
const getCategoryGroupsRequest = () => {
  return {
    type: types.GET_GROUP_CATEGORY_REQUEST,
  };
};

const getCategoryGroupsSuccess = (payload) => {
  return {
    type: types.GET_GROUP_CATEGORY_SUCCESS,
    payload,
  };
};

const getCategoryGroupsError = () => {
  return {
    type: types.GET_GROUP_CATEGORY_ERROR,
  };
};

// SENT iNVITATIONS
const getSentInvitationRequest = () => {
  return {
    type: types.GET_SENT_INVITATION_REQUEST,
  };
};

const getSentInvitationSuccess = (payload) => {
  return {
    type: types.GET_SENT_INVITATION_SUCCESS,
    payload,
  };
};

const getSentInvitationError = () => {
  return {
    type: types.GET_SENT_INVITATION_ERROR,
  };
};

// SENT INSPIRATION
const getInspirationRequest = () => {
  return {
    type: types.GET_INSPIRATION_REQUEST,
  };
};

const getInspirationSuccess = (payload) => {
  return {
    type: types.GET_INSPIRATION_SUCCESS,
    payload,
  };
};

const getInspirationError = () => {
  return {
    type: types.GET_INSPIRATION_ERROR,
  };
};

// add requests
const addGroupsRequest = () => {
  return {
    type: types.ADD_GROUPS_REQUEST,
  };
};

const addGroupsSuccess = (payload) => {
  return {
    type: types.ADD_GROUPS_SUCCESS,
    payload,
  };
};

const addGroupsError = () => {
  return {
    type: types.ADD_GROUPS_ERROR,
  };
};

// POST FUNCTION'S
const addGroups = (payload) => (dispatch) => {
  // middleware --> thunk
  if (payload) {
    dispatch(addGroupsRequest()); // isLoading : -- true

    return axios
      .post(`${BASE_URL_USER}/api/v1/group`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((r) => {
        dispatch(addGroupsSuccess());
      })
      .catch((e) => {
        dispatch(addGroupsError());
      });
  }
};

// GET FUNCTIONSS

// banner
const getBanners = (dispatch) => {
  dispatch(getBannerRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=HOME_BANNERS`)
    .then((response) => dispatch(getBannerSuccess(response.data)))
    .catch((e) => {
      dispatch(getBannerError());
    });
};
const getInnerBanners = (dispatch) => {
  dispatch(getInternalBannerRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=WEB_HOME_BANNERS`)
    .then((response) => dispatch(getInternalBannerSuccess(response.data)))
    .catch((e) => {
      dispatch(getInternalBannerError());
    });
};
//CATEGORY
const getCategory = (dispatch) => {
  dispatch(getCategoryRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=PRODUCTS`)
    .then((response) => dispatch(getCategorySuccess(response.data)))
    .catch((e) => {
      dispatch(getCategoryError());
    });
};

//trendingGreeting
const getTrendingGreeting = (dispatch) => {
  dispatch(getTrendingGreetingRequest());

  // Make the first API call to get the categoryId
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "GREETINGS"
      );
      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(`${BASE_URL_MEDIA}/canvas/category/all?categoryId=${categoryId}`)
          .then((response) => {
            dispatch(getTrendingGreetingSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getTrendingGreetingError());
          });
      } else {
        dispatch(getTrendingGreetingError());
      }
    })
    .catch((error) => {
      dispatch(getTrendingGreetingError());
    });
};

//trendingInvitation
const getTrendingInvitation = (dispatch) => {
  dispatch(getTrendingInvitationRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "INVITATIONS"
      );

      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(`${BASE_URL_MEDIA}/canvas/get/all?categoryId=${categoryId}`)
          .then((response) => {
            dispatch(getTrendingInvitationSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getTrendingInvitationError());
          });
      } else {
        dispatch(getTrendingInvitationError());
      }
    })
    .catch((error) => {
      dispatch(getTrendingInvitationError());
    });
};

//INSPIRATIONS
const getInspiration = (currentPage, itemsPerPage) => (dispatch) => {
  dispatch(getInspirationRequest());
  return axios
    .get(
      `${BASE_URL_WISHLIST}/inspirationboard/getinspirationboard?page=${currentPage}&size=${itemsPerPage}`,
      { withCredentials: true },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Token: 123456,
        },
      }
    )
    .then((response) => dispatch(getInspirationSuccess(response.data.payload)))
    .catch((e) => {
      dispatch(getInspirationError());
    });
};

//trendingProduct
const getTrendingProducts = (dispatch) => {
  dispatch(getTrendingProductRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/trendingProducts?page=0&size=10`
    )
    .then((response) =>
      dispatch(getTrendingProductSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getTrendingProductError());
    });
};

//AllProduct
const getAllProductsHome = (dispatch) => {
  dispatch(getAllProductHomeRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/findAllProducts?page=0&size=150`
    )
    .then((response) =>
      dispatch(getAllProductHomeSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getAllProductHomeError());
    });
};

//All home decor
const getAllHomedecor = (dispatch) => {
  dispatch(getAllHomeDecorRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/get?category=HOMEDECOR&page=0&size=100`
    )
    .then((response) =>
      dispatch(getAllHomeDecorSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getAllHomeDecorError());
    });
};

//AllPots
const getAllPots = (dispatch) => {
  dispatch(getAllPotsRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/get?category=POTS&page=0&size=100`
    )
    .then((response) =>
      dispatch(getAllPotsSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getAllPotsError());
    });
};

//All frames decor
const getWishfyFrames = (dispatch) => {
  dispatch(getWishfyFramesRequest());
  return axios
    .get(
      `${BASE_URL_FLORAHUB}/inventory/api/v1/product/get?category=PLANTS&page=0&size=100`
    )
    .then((response) =>
      dispatch(getWishfyFramesSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getWishfyFramesError());
    });
};

// GREET
const getGreet = (dispatch) => {
  dispatch(getGreetRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "GREETINGS"
      );

      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(
            `${BASE_URL_MEDIA}/media/file/admin/get/bygroupandcategoryanddimension?imageGroup=TEMPLATE&categoryId=${categoryId}&page=0&pageSize=6`
          )
          .then((response) => {
            dispatch(getGreetSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getGreetError());
          });
      } else {
        dispatch(getGreetError());
      }
    })
    .catch((error) => {
      dispatch(getGreetError());
    });
};

// invitations
const getInvitation = (dispatch) => {
  dispatch(getInvitationRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "INVITATIONS"
      );

      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(
            `${BASE_URL_MEDIA}/media/file/admin/get/bygroupandcategoryanddimension?imageGroup=TEMPLATE&categoryId=${categoryId}&page=0&pageSize=35`
          )
          .then((response) => {
            dispatch(getInvitationSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getInvitationError());
          });
      } else {
        dispatch(getInvitationError());
      }
    })
    .catch((error) => {
      dispatch(getInvitationError());
    });
};

// ALL GREETINGS
const getAllGreetings = (dispatch) => {
  dispatch(getAllGreetingsRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "GREETINGS"
      );

      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(`${BASE_URL_MEDIA}/canvas/get/all?categoryId=${categoryId}`)
          .then((response) => {
            dispatch(getAllGreetingsSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getAllGreetingsError());
          });
      } else {
        dispatch(getAllGreetingsError());
      }
    })
    .catch((error) => {
      dispatch(getAllGreetingsError());
    });
};

//ALL invitations
const getAllInvitation = (dispatch) => {
  dispatch(getAllInvitationRequest());
  return axios
    .get(`${BASE_URL_MEDIA}/config/categories/all?screenTypes=DASHBOARD`)
    .then((response) => {
      const greetingsCategory = response.data.find(
        (category) => category.categoryName === "INVITATIONS"
      );

      if (greetingsCategory) {
        const categoryId = greetingsCategory.categoryId;
        return axios
          .get(`${BASE_URL_MEDIA}/canvas/get/all?categoryId=${categoryId}`)
          .then((response) => {
            dispatch(getAllInvitationSuccess(response.data));
          })
          .catch((error) => {
            dispatch(getAllInvitationError());
          });
      } else {
        dispatch(getAllInvitationError());
      }
    })
    .catch((error) => {
      dispatch(getAllInvitationError());
    });
};

//sent invitations
const getSentInvitation = (dispatch) => {
  dispatch(getSentInvitationRequest());
  return axios
    .get(`${BASE_URL_EVENT}/invitations/get/all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getSentInvitationSuccess(response.data.payload.content))
    )
    .catch((e) => {
      dispatch(getSentInvitationError());
    });
};

//All groups
const getGroupDetails = (dispatch) => {
  dispatch(getAllGroupsRequest());
  return axios
    .get(`${BASE_URL_USER}/api/v1/group/get-group`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) => dispatch(getAllGroupsSuccess(response.data.payload)))
    .catch((e) => {
      dispatch(getAllGroupsError());
    });
};

const fetchInspirationBoard = (formData) => {
  return (dispatch) => {
    dispatch(fetchInspirationBoardRequest());

    axios
      .get(
        `${BASE_URL_WISHLIST}/inspirationboard/getInspirationBoardByFilters`,
        formData,
        {
          headers: { accept: "/" },
        }
      )
      .then((response) => {
        dispatch(fetchInspirationBoardSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchInspirationBoardFailure(error.message));
      });
  };
};

// GIFT DIARY
const sendImageRequest = () => {
  return {
    type: types.ADD_IMAGE_REQUEST, // isLoading : true
  };
};

const sendImageSuccess = (payload) => {
  return {
    type: types.ADD_IMAGE_SUCCESS,
    payload,
  };
};

const sendImageError = () => {
  return {
    type: types.ADD_IMAGE_ERROR,
  };
};
const sendImages = (payload) => (dispatch) => {
  // middleware --> thunk
  if (payload) {
    dispatch(sendImageRequest()); // isLoading : -- true

    return axios
      .post(
        `${BASE_URL_MEDIA}/media/file/admin/upload/raw?imageGroup=USER_CARD_IMAGES`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((r) => {
        dispatch(sendImageSuccess());
      })
      .catch((e) => {
        dispatch(sendImageError());
      });
  }
};

//get Category group
const getGroupCategory = (dispatch) => {
  dispatch(getCategoryGroupsRequest());
  return axios
    .get(`${BASE_URL_USER}/api/v1/group/get-category`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((response) =>
      dispatch(getCategoryGroupsSuccess(response.data.payload))
    )
    .catch((e) => {
      dispatch(getCategoryGroupsError());
    });
};

// GIFT DIARY
const sendGreetingsRequest = () => {
  return {
    type: types.SEND_GREETINGS_REQUEST, // isLoading : true
  };
};

const sendGreetingsSuccess = (payload) => {
  return {
    type: types.SEND_GREETINGS_SUCCESS,
    payload,
  };
};

const sendGreetingsError = () => {
  return {
    type: types.SEND_GREETINGS_ERROR,
  };
};

const sendGreetingsDiary = (payload) => (dispatch) => {
  // middleware --> thunk
  if (payload) {
    dispatch(sendGreetingsRequest()); // isLoading : -- true

    return axios
      .post(`${BASE_URL_EVENT}/greetings/send`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((r) => {
        dispatch(sendGreetingsSuccess());
      })
      .catch((e) => {
        dispatch(sendGreetingsError());
      });
  }
};

export {
  getBanners,
  getInvitation,
  getGreet,
  getTrendingGreeting,
  getTrendingInvitation,
  getCategory,
  getTrendingProducts,
  getAllGreetings,
  getAllInvitation,
  getSentInvitation,
  getAllProductsHome,
  getAllHomedecor,
  getAllPots,
  getWishfyFrames,
  getInspiration,
  getGroupCategory,
  addGroups,
  getGroupDetails,
  addGiftDiary,
  getInnerBanners,
  getOrderHistory,
  getEventDetails,
  sendGreetingsDiary,
  getBanquet,
  getGreetingSentDetails,
  getGreetingReceiveDetails,
  getGiftDairy,
  sendImages,
  getInterest,
  fetchInspirationBoard,
};
